import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs';
import { Worker } from './worker.class';
import { AssignCase } from './assignCases.class';
import { CacheData } from './entities/cacheData.class';
import { UserData } from './entities/userData.class';
import { CacheVisit } from './entities/cacheVisit.class';
import { CacheCarePlanItem } from './entities/cacheCarePlanItem.class';
import { VisitDirectionsEntity } from './entities/visitDirectionsEntity.class';
import { CacheAssignedPatient } from './entities/cacheAssignedPatient.class';
import { TimeConstraint } from './entities/timeConstraint.class';
import { CacheCoordinates } from './entities/cacheCoordinates.class';
import { environment } from 'src/environments/environment';
import { StorageService } from './storageservice';
import { Slot } from './entities/slot.class';
import { NetworkStatus, Network } from '@capacitor/network';
import { PluginListenerHandle } from '@capacitor/core';
import { MemberInfo } from './entities/memberInfo.class';
import { AdjustmentSlot } from './entities/adjustmentSlot.class';
import { Translate } from './translate';
import { CachePatientTime } from './entities/cachePatientTime.class';
import * as moment from 'moment';
import { DateFormat, DateTimeFormat, DateTimeWebFormat, MomentDefaultFormat } from '../shared/entities/constantsExport.class';
import { UptimeService } from './uptimeService.service';

import { throwError, TimeoutError } from 'rxjs';
import { catchError, finalize, tap, timeout } from 'rxjs/operators';
import { interval } from 'rxjs';
import { Subject } from 'rxjs';
import { CacheWorkerCoordinates } from './entities/cacheWorkerCoordinates.class';
import { AvailableShift } from './entities/availableShift.class';
import { MomentFormats } from 'src/shared/entities/momentFormats.class';
import { CacheContiguousVisits } from './entities/cacheContiguousVisits.class';
import { CacheConfigurableListItem } from './entities/cacheConfigurableListItem.class';
import { CoPhone } from './entities/coPhone';
import { NewRelicService } from './newrelic.service';
import { ErrandMiles } from './entities/errandMiles.class';

@Injectable()
export class RequestService {
    public access_token: string = "";
    public bing_key: string = "AvNDcayNqyBC2kAevPbc8ZkWyw13lfciawvVEUJpKXaYhOC93wq9Bd-kJ9lGhJym";
    businessConfigurations: any = [];
    userID: number = null;
    businessID: number = null;
    memberID: number = null;
    workerData: Worker;
    workerClients: any = [];
    loginResponse: any;
    baseUrl: string = "";
    defaultLocation: any = {};
    supportedUploadTypes: string = ".jpg, .jpeg, .png, .pdf, .doc, .txt, .docx";
    maximumUploadSize: number = 10;
    notificationCenterData: any = [];
    userData: UserData = new UserData("", "", "", "", false);
    MAX_LOCATION_ATTEMPTS: number = 3;
    visitList: AssignCase[];

    APP_VERSION: string = "1.0.2";

    uid: string;


    networkStatus: NetworkStatus;
    networkListener: PluginListenerHandle;
    isOnline: any = false;
    documentPageName: any;
    baseDocumentUrl: string = "";
    pastDays: number = 0;

    source = interval(3000);
    pingTimes: number = 0;
    maxPingTimes: number = 5;
    pingAllowedDelay: number = 5000; //ms
    lastMoment: any;
    offlineMode = false;
    delayStr: string = "";
    pingIndex: number = 0;
    timeArray: any[] = [];
    public offlineModeObservable = new Subject<boolean>();
    public readonly visitSyncFailedKey = "VisitsSyncFailed";

    constructor(
        private http: HttpClient,
        private storage: StorageService,
        private uptimeService: UptimeService,
        private newRelicService: NewRelicService
    ) {
        this.baseDocumentUrl = environment.documentUrl;
        this.baseUrl = environment.serviceUrl;
        this.APP_VERSION = environment.build_VersionNumber;

        // this.networkListener =  Network.addListener('networkStatusChange', (status) => {
        //     this.networkStatus = status;
        //     if (this.networkStatus.connected) {
        //         this.isOnline
        //     }
        // });
        this.initializeNetworkListener();
    }

    private async initializeNetworkListener() {
        this.networkListener = await Network.addListener('networkStatusChange', (status) => {
            this.networkStatus = status;
            if (this.networkStatus.connected) {
                this.isOnline = true;
            } else {
                this.isOnline = false;
            }
        });
    }

    getServerTime() {
        return this.getUTCTime().then(commonTime => {
            if (moment(commonTime, DateTimeWebFormat).format(DateTimeFormat) != localStorage.getItem("commonTime")) {
                localStorage.setItem("commonTime", moment(commonTime, DateTimeWebFormat).format(DateTimeFormat));
                //difference between phone time and server time
                let commonDiff = moment().diff(moment(commonTime, DateTimeWebFormat)) - moment().utcOffset() * 60000;
                if (Math.abs(commonDiff) > this.uptimeService.uptimeTolerance * 60000) commonDiff = 0;
                localStorage.setItem("commonDiff", commonDiff.toString());

                if (this.uptimeService.isCordova()) {
                    this.uptimeService.syncAndStoreOnlineTime(commonTime);
                }
            }
        }).catch((e) => {
            console.log("error: " + e);
        });
    }

    getAllTimes() {
        var endDate = moment().toISOString();
        var startDate = moment().toISOString();
        startDate = this.pastDays > 0 ? moment(startDate).add(-this.pastDays, 'd').toISOString() : startDate;
        this.getCacheVisits(moment(startDate).format(DateTimeFormat), moment(endDate).format(DateTimeFormat), false).then(visits => {
            this.storage.set(this.uptimeService.cacheVisitKey, visits);
        });
    }

    assignedPatientTimePromises(data: CacheAssignedPatient[]) {
        let commonTime = moment(localStorage.getItem("commonTime"), DateTimeFormat);
        for (var i = 0; i < data.length; i++) {
            data[i].PatientTime = moment(data[i].PatientTime, DateTimeWebFormat).format(DateTimeFormat);
            data[i].PatientZone = moment(data[i].PatientTime, DateTimeWebFormat).diff(commonTime);
        }
        return data;
    }

    visitTimePromises(data: CacheVisit[]) {
        let commonTime = moment(localStorage.getItem("commonTime"), DateTimeFormat);
        for (var i = 0; i < data.length; i++) {
            data[i].PatientTime = moment(data[i].PatientTime, DateTimeWebFormat).format(DateTimeFormat);
            data[i].PatientZone = moment(data[i].PatientTime, DateTimeWebFormat).diff(commonTime);
        }
        return data;
    }

    getAppVersion() {
        return this.APP_VERSION;
    }

    needToUpdateApplication(currentVersion) {
        return new Promise<any>(resolve => {
            this.getUpcomingVisitsForWorker("Business/NeedToUpdateApplication",
                {
                    applicationName: "AnkotaManosMobile",
                    currentVersion: currentVersion
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    forgetPassword(username): Promise<any> {
        return new Promise(resolve => {
            this.http.get(this.baseUrl + 'security/CheckUserForgotPassword?username=' + username)
                .subscribe(
                    data => {
                        resolve(data);
                    },
                    err => {
                        resolve({
                            "error": err.error
                        })
                    }
                )
        })
    }

    tryLogin(user, password): Promise<any> {
        return new Promise(resolve => {
            var creds = "grant_type=password&username=" + user + "&password=" + password;
            var headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });


            this.http.post(this.baseUrl + "token", creds, { headers: headers })
                .subscribe(
                    data => {
                        this.access_token = data["access_token"];
                        this.workerData = new Worker(parseInt(data["memberId"]), data["lastName"], data["firstName"], parseInt(data["userId"]),
                            parseInt(data["userTypeId"]), parseInt(data["businessId"]), data["stringWorkerId"], data["businessName"], data["businessAlias"], data["consentNotificationReceived"], data["isNewrelicEnable"]);
                        this.userData.NeedsPasswordChange = parseInt(data["NeedsPasswordChange"]) == 1;
                        this.storage.set("UserData", this.workerData).then(data => {
                            resolve(data);
                        });
                    },
                    err => {
                        resolve({
                            "error": err.error
                        })
                    }
                );
        });
    }

    setData(data2) {
        this.access_token = data2["access_token"];
        this.workerData = new Worker(
            parseInt(data2["memberId"]),
            data2["lastName"],
            data2["firstName"],
            parseInt(data2["userId"]),
            parseInt(data2["userTypeId"]),
            parseInt(data2["businessId"]),
            data2["stringWorkerId"],
            data2["businessName"],
            data2["businessAlias"],
            data2["consentNotificationReceived"],
            data2["isNewrelicEnable"]);
        this.userData.NeedsPasswordChange = false;
        this.storage.set("UserData", this.workerData).then(data => {
        });
    }

    getUpcomingVisits(startDate, endDate) {
        return new Promise<any>(resolve => {
            this.getUpcomingVisitsForWorker("Visit/GetUpcomingVisitsForWorker",
                {
                    memberId: this.workerData.MemberId,
                    startDate: startDate,
                    endDate: endDate,
                    clientDate: new Date().toString().split(" G")[0]
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    checkIfAllowed(visit: CacheVisit): Promise<TimeConstraint> {
        return new Promise<TimeConstraint>(resolve => {
            this.checkAllowed("Visit/CheckIfWorkerIsAllowed",
                {
                    workerId: this.workerData.MemberId,
                    patientId: visit.PatientId,
                    businessId: this.workerData.BusinessId,
                    userId: this.workerData.UserId,
                    arrivalTime: visit.ArrivalTime,
                    serviceOrderId: visit.ServiceOrderId
                }).subscribe(data => {
                    resolve(data);
                })
        });
    }

    getMainMenuPagesFromConfiguration(): Promise<any> {
        return new Promise<any>(resolve => {
            this.getMainMenuPagesConfiguration("Business/GetMainMenuPagesConfiguration",
                {
                    businessId: this.workerData.BusinessId,
                    userId: this.workerData.UserId,
                    userTypeId: this.workerData.UserTypeId,
                    language: Translate.currentLanguage
                }).subscribe(data => {
                    resolve(data);
                })
        });
    }

    uploadSignatureForPatient(imgString: string, date: number, serviceOrderId: number, isWorkerSignature: boolean): Promise<any> {
        return new Promise<any>(resolve => {
            this.uploadSignatureToServer("Visit/UploadAndSaveSignatureForPatient",
                {
                    imageString: imgString,
                    imageDate: date,
                    serviceOrderId: serviceOrderId,
                    isWorkerSignature: false
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    uploadSignature(imgString: string, date: number, serviceOrderId: number, isWorkerSignature: boolean): Promise<any> {
        return new Promise<any>(resolve => {
            this.uploadSignatureToServer("Visit/UploadAndSaveSignature",
                {
                    imageString: imgString,
                    imageDate: date,
                    serviceOrderId: serviceOrderId,
                    isWorkerSignature: isWorkerSignature
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    uploadSignatures(imgString: string, date: number, visit: CacheVisit, isWorkerSignature: boolean): Promise<any> {
        var serviceOrderIds: number[] = [];
        serviceOrderIds.push(visit.ServiceOrderId);
        visit.ContiguousVisits.forEach(cv => serviceOrderIds.push(cv.ServiceOrderId));
        return new Promise<any>(resolve => {
            this.uploadSignatureToServer("Visit/UploadAndSaveSignatures",
                {
                    imageString: imgString,
                    imageDate: date,
                    serviceOrderIds: serviceOrderIds,
                    isWorkerSignature: isWorkerSignature
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    getBusinessConfigurations(): Promise<any> {
        return new Promise<any>(resolve => {
            this.getConfigurationsForBusiness("Business/GetTelephonyConfigurationsByBusiness",
                {
                    businessId: this.workerData.BusinessId
                }).subscribe(data => {
                    this.businessConfigurations = data;
                    resolve(data);
                });
        });
    }

    getBusinessConfigurationByUsernameAndPassword(username: string, password: string, message: string = ''): Promise<any> {
        return new Promise<any>(resolve => {
            this.getConfigurationByUsernameAndPassword("Business/GetTelephonyConfigurationsByUsernameAndPassword",
                {
                    userName: username,
                    password: password,
                    message: message
                }).subscribe(data => {
                    resolve(data);
                });
        });
    }

    getUpcomingDetails(serviceOrderId, visitList): Promise<any> {
        return new Promise<any>(resolve => {
            this.getUpcomingVisitDetails("Visit/GetVisitDetailsByServiceOrderId",
                {
                    serviceOrderId: serviceOrderId,
                    visitList: visitList,
                    memberId: this.workerData.MemberId,
                    date: new Date().toString().split("G")[0],
                    businessId: this.workerData.BusinessId
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    getVisitsWithMatchedSkillsForWorker(startDate, endDate): Promise<any> {
        return new Promise<any>(resolve => {
            this.getVisitsWithMatchingSkills("Visit/GetVisitsWithMatchingSkills",
                {
                    businessId: this.workerData.BusinessId,
                    memberId: this.workerData.MemberId,
                    startDate: startDate,
                    endDate: endDate
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    updateVisitStatusTechnician(serviceOrderId, technician, status, updateNotes = "", statusReasonId = 0): Promise<CacheVisit> {
        return new Promise<CacheVisit>(resolve => {
            this.updateVisitStatusAndTechnician("Visit/UpdateVisitStatusAndTechinician",
                {
                    serviceOrderId: serviceOrderId,
                    memberId: technician,
                    status: status,
                    userId: this.workerData.UserId,
                    userTypeId: this.workerData.UserTypeId,
                    businessId: this.workerData.BusinessId,
                    updateWorkerNote: updateNotes,
                    baseTableValue: statusReasonId
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    updateVisitAppointmentDate(serviceOrderId, appointmentDate): Promise<CacheVisit> {
        return new Promise<CacheVisit>(resolve => {
            this.updateVisitStatusAndTechnician("Visit/UpdateVisitAppointmentDate",
                {
                    serviceOrderId: serviceOrderId,
                    appointmentDate: appointmentDate,
                    userId: this.workerData.UserId
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    declineVisit(visit, technician, status): Promise<CacheVisit> {
        return new Promise<CacheVisit>(resolve => {
            this.declineVisitAndMarkAsSearched("Visit/DeclineVisit",
                {
                    visit: visit,
                    memberId: technician,
                    status: status
                }).subscribe(data => {
                    resolve(data);
                });
        });
    }

    deviceWasAlreadyLogged(deviceIdentifier, userId): Promise<any> {
        return new Promise<any>(resolve => {
            this._deviceWasAlreadyLogged("TwoFactorAuth/DeviceWasAlreadyLogged",
                {
                    deviceIdentifier: deviceIdentifier,
                    userId: userId
                }).subscribe(data => {
                    resolve(data);
                });
        });
    }


    getVisitsForCalendar(startDate, endDate): Promise<any> {
        return new Promise<any>(resolve => {
            if (this.workerData !== undefined && this.workerData != null) {
                this.getWorkerVisitsForCalendar("Visit/GetWorkerVisitsForCalendar",
                    {
                        memberId: this.workerData.MemberId,
                        startDate: startDate,
                        endDate: endDate
                    }).subscribe(data => {
                        resolve(data);
                    });
            } else {
                resolve([]);
            }
        })
    }

    getVisitHistory(startDate, endDate, clientDate): Promise<any> {
        return new Promise<any>(resolve => {
            if (this.workerData) {
                this.getVisitHistoryForWorker("Visit/GetVisitHistoryForWorker",
                    {
                        memberId: this.workerData.MemberId,
                        startDate: startDate,
                        endDate: endDate,
                        clientDate: clientDate
                    }).subscribe(data => {
                        resolve(data);
                    });
            } else {
                resolve([]);
            }
        })
    }

    getPayrollHistory(startDate, endDate): Promise<any> {
        return new Promise<any>(resolve => {
            this.getWorkerVisitsForCalendar("Visit/GetPayrollHistoryForWorker",
                {
                    memberId: this.workerData.MemberId,
                    startDate: startDate,
                    endDate: endDate
                }).subscribe(data => {
                    resolve(data);
                });
        })
    }

    getWeeklyHoursForWorker(startDate, endDate): Promise<any> {
        return new Promise<any>(resolve => {
            this.getWeeklyHoursForTotalWorker("Visit/GetWeeklyHoursForWorker",
                {
                    departmentId: this.workerData.BusinessId,
                    memberId: this.workerData.MemberId,
                    startDate: startDate,
                    endDate: endDate
                }).subscribe(data => {
                    resolve(data);
                });
        })
    }

    uploadFile(file, serviceOrderId) {
        return new Promise<any>(resolve => {
            var formData: FormData = new FormData();
            formData.append(file.name, file, file.name);
            formData.append("serviceOrderId", serviceOrderId.toString());
            formData.append("memberId", this.workerData.MemberId.toString());
            this.http.post(this.baseUrl + "Visit/UploadVisitDocuments", formData).subscribe((data) => {
                resolve(data);
            });
        })
    }

    savePatientConfirmation(file, serviceOrderId) {
        return new Promise<any>(resolve => {
            this.savePatientConfirmationUrl("Visit/SavePatientConfirmation",
                {
                    file: file,
                    serviceOrderId: serviceOrderId,
                    memberId: this.workerData.MemberId
                }).subscribe(data => {
                    resolve(data);
                });
        });
    }

    getWeeklyHoursSummary(startDate, endDate): Promise<any> {
        return new Promise<any>(resolve => {
            this.getWeeklyHoursSummaryWorker("Visit/GetWeeklyHoursSummary",
                {
                    departmentId: this.workerData.BusinessId,
                    memberId: this.workerData.MemberId,
                    startDate: startDate,
                    endDate: endDate
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    getPayrollSummary(invoiceId): Promise<any> {
        return new Promise<any>(resolve => {
            this.getWorkerVisitsForCalendar("Visit/GetPayrollSummary",
                {
                    invoiceId: invoiceId
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    getVisitsForNotificationCenter() {
        return new Promise<any>(resolve => {
            this.getVisitsForNotification("Visit/GetVisitsForNotificationCenter",
                {
                    memberId: this.workerData.MemberId,
                    startDate: new Date().toString().split("G")[0]
                }).subscribe(data => {
                    resolve(data);
                });
        })
    }

    getTimesheets(serviceOrderId, businessId) {
        return new Promise<any>(resolve => {
            this.getTimesheetUrls("Visit/GetTimesheets",
                {
                    serviceOrderId: serviceOrderId,
                    businessId: businessId
                }).subscribe(data => {
                    resolve(data);
                });
        })
    }

    saveVisitNotes(serviceOrderId, message) {
        return new Promise<any>(resolve => {
            this.saveNotesForVisits("Visit/SaveVisitNotes",
                {
                    serviceOrderId: serviceOrderId,
                    notesMessage: message,
                    userId: this.workerData.UserId,
                    businessId: this.workerData.BusinessId
                }).subscribe(data => {
                    resolve(data);
                });
        })
    }

    getErrandMiles(serviceOrderId) {
        return new Promise<any>(resolve => {
            this.getErrandMilesForVisits("Visit/GetErrandMiles",
                {
                    serviceOrderId: serviceOrderId,
                }).subscribe(data => {
                    resolve(data);
                });
        })
    }

    
    saveErrandMiles(errandMilesList: ErrandMiles[]) {
        return new Promise<any>(resolve => {
            this._updatePhonesDetails("Visit/SaveErrandMiles", {
                errandMilesList: errandMilesList
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    cancelVisit(serviceOrderId, notes, statusReasonID) {
        return new Promise<any>(resolve => {
            this.saveNotesForVisits("Visit/CancelVisit",
                {
                    serviceOrderId: serviceOrderId,
                    notes: notes,
                    statusReasonID: statusReasonID

                }).subscribe(data => {
                    resolve(data);
                });
        })
    }

    getVisitTypeDetails(serviceOrderId) {
        return new Promise<any>(resolve => {
            this._getVisitTypeDetails("Visit/GetVisitTypeDetails",
                {
                    serviceOrderId: serviceOrderId
                }).subscribe(data => {
                    resolve(data);
                });
        })
    }

    sendAuthCodeToWorker(): Promise<any> {
        return new Promise<any>(resolve => {
            this._sendAuthCodeToWorker("TwoFactorAuth/SendCodeToWorker",
                {
                    memberId: this.workerData.MemberId
                }).subscribe(data => {
                    resolve(data);
                });
        })
    }

    logAuthCode(auth): Promise<any> {
        return new Promise<any>(resolve => {
            this._logAuthCode("TwoFactorAuth/LogAuthCode",
                {
                    auth: auth
                }).subscribe(data => {
                    resolve(data);
                });
        })
    }

    acceptTimes(serviceOrderId, arrival, departure, duration): Promise<CacheVisit> {
        return new Promise<CacheVisit>(resolve => {
            this.acceptDepartureTime("Visit/UpdateVisitDepartDate", {
                serviceOrderID: serviceOrderId,
                ArrivalDate: arrival,
                DepartureDate: departure,
                workerId: this.workerData.MemberId,
                userId: this.workerData.UserId,
                businessId: this.workerData.BusinessId,
                duration: duration
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    getUserMessagesForNotificationCenter(): Promise<any> {
        return new Promise<any>(resolve => {
            this._getUserMessagesForNotificationCenter("Visit/GetMessagesForUser", {
                userId: this.workerData.UserId,
                userTypeId: this.workerData.UserTypeId
            }).subscribe(data => {
                resolve(data);
            })
        });
    }

    sendMessageForUser(title,message): Promise<any> {
        return new Promise<any>(resolve => {
            this._sendMessageForUser("Visit/SendMessageForUser", {
                orgId: this.workerData.BusinessId,
                userId: this.workerData.MemberId,
                userTypeId: this.workerData.UserTypeId,
                title: title,
                message: message
            }).subscribe(data => {
                resolve(data);
            })
        });
    }

    getExpiringHrRequirementsForNotificationCenter(): Promise<any> {
        return new Promise<any>(resolve => {
            this._getExpiringHrRequirementsForNotificationCenter("Visit/GetExpiringHRRequirements", {
                businessId: this.workerData.BusinessId,
                memberId: this.workerData.MemberId,
                checkedDate: new Date().toString().split(" G")[0]
            }).subscribe(data => {
                resolve(data);
            })
        })
    }

    markMessagesAsRead(messageList): Promise<any> {
        return new Promise<any>(resolve => {
            this._getExpiringHrRequirementsForNotificationCenter("Visit/MarkMessagesAsRead", {
                messageList: messageList
            }).subscribe(data => {
                resolve(data);
            })
        })
    }

    getCarePlanItemHistory(patientID, visitItemID, numberOfDays): Promise<any> {
        return new Promise<any>(resolve => {
            this._getCarePlanItemHistory("Visit/GetCarePlanItemHistory", {
                patientId: patientID,
                visitItemId: visitItemID,
                NumberOfDays: numberOfDays
            }).subscribe(data => {
                resolve(data);
            })
        })
    }

    getCarePlanItemsHistoryAll(visitItemIDs, patientID, numberOfDays): Promise<any> {
        return new Promise<any>(resolve => {
            this._getCarePlanItemHistory("Visit/GetCarePlanItemsHistoryAll", {
                VisitItemIds: visitItemIDs,
                PatientId: patientID,
                NumberOfDays: numberOfDays
            }).subscribe(data => {
                resolve(data);
            })
        })
    }

    getCarePlanItems(serviceOrderId): Promise<CacheCarePlanItem[]> {
        return new Promise<CacheCarePlanItem[]>(resolve => {
            this._getCarePlanItems("Visit/GetCarePlanItems", {
                serviceOrderId: serviceOrderId,
                userName: btoa(this.userData.Username),
                password: btoa(this.userData.Password),
                businessId: this.workerData.BusinessId,
                language: Translate.currentLanguage
            }).subscribe(data => {
                resolve(data);
            })
        })
    }

    getAdditionalCarePlanItems(): Promise<CacheCarePlanItem[]> {
        return new Promise<CacheCarePlanItem[]>(resolve => {
            this._getCarePlanItems("Visit/GetAdditionalCarePlanItems", {
                serviceOrderId: 0,
                userName: btoa(this.userData.Username),
                password: btoa(this.userData.Password),
                businessId: this.workerData.BusinessId,
                language: Translate.currentLanguage
            }).subscribe(data => {
                resolve(data);
            })
        })
    }

    saveVitalSignCarePlan(visitItemId, serviceOrderId, reportedValue, planId, patientId): Promise<any> {
        return new Promise<any>(resolve => {
            this._saveVitalSignCarePlan("Visit/SaveVitalSignCarePlanItem", {
                visitItemId: visitItemId,
                serviceOrderId: serviceOrderId,
                reportedValue: reportedValue,
                planId: planId,
                patientId: patientId
            }).subscribe(data => {
                resolve(data);
            })
        })
    }

    saveCarePlanItemValues(cpToSave): Promise<any> {
        return new Promise<any>(resolve => {
            this._saveVitalSignCarePlan("Visit/SaveCarePlanItemValues", {
                dataJson: JSON.stringify(cpToSave)
            }).subscribe(data => {
                resolve(data);
            })
        })
    }

    sendForLogging(message, obj?): Promise<any> {
        return new Promise<any>(resolve => {
            this._sendForLogging("Business/LogMessageFromClient", {
                message: message,
                dataJson: obj ? JSON.stringify(obj) : ""
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    checkGpsCoordinates(serviceOrderId, data: CacheCoordinates, isArrival = false): Promise<any> {
        return new Promise<any>(resolve => {
            this._checkGpsCoordinates("Visit/CheckGPSCoordinates", {
                serviceOrderId: serviceOrderId,
                businessId: this.workerData.BusinessId,
                latitude: data.Latitude,
                longitude: data.Longitude,
                isArrival: isArrival,
                timestamp: data.TimeStamp
            }).subscribe(data => {
                resolve(data);
            });
        });
    }
    CheckIfAnotherWorkerIsClockedIn(memberId: number, businessId, patientID: number, serviceTypeID: number, startDate, endDate) {
        return new Promise<any>(resolve => {
            this._checkIfAnotherWorkerIsClockedIn("Visit/CheckIfAnotherWorkerIsClockedIn", {
                memberId: memberId,
                businessId: businessId,
                patientID: patientID,
                serviceTypeID: serviceTypeID,
                startDate: startDate,
                endDate: endDate
            }).subscribe(data => {
                resolve(data);
            });
        });
    }
    checkIfShouldDepart(serviceOrderId, currentTime): Promise<any> {
        return new Promise<any>(resolve => {
            this._checkIfShouldDepart("Visit/CheckDepartureAndGetMessage", {
                serviceOrderId: serviceOrderId,
                userTime: currentTime
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    updateVisitBreakDuration(serviceOrderId, visitBreakDuration): Promise<any> {
        return new Promise<any>(resolve => {
            this._updateVisitBreakDuration("Visit/UpdateVisitBreakDuration", {
                serviceOrderId: serviceOrderId,
                visitBreakDuration: visitBreakDuration
            }).subscribe(data => {
                resolve(data);
            });
        });
    }
    

    getPatientTime(businessId, patientID) {
        return new Promise<string>(resolve => {
            this._getPatientTime("Visit/GetPatientTime", {
                businessId: businessId,
                patientId: patientID
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    async getPatientTime2(businessId, patientID) {
        return await new Promise<any>(resolve => {
            this._getPatientTime("Visit/GetPatientTime", {
                businessId: businessId,
                patientId: patientID
            }).subscribe(data => {
                let result = new CachePatientTime(businessId, patientID, data);
                resolve(result);
            });
        });
    }

    async getUTCTime() {
        return await new Promise<any>(resolve => {
            this._getUTCTime("Visit/GetUTCTime", { timezone: 0 }).subscribe(data => {
                resolve(data);
            });
        });
    }

    getContiguousVisitList(businessId, visitList) {
        return new Promise<any>(resolve => {
            this._getContiguousVisitList("Visit/GetContiguousVisits", {
                businessId: businessId,
                visitList: visitList
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    getConfigurationValueByMessage(businessId, message) {
        return new Promise<any>(resolve => {
            this._getConfigurationValueByMessage("Business/GetConfigurationValueByMessage", {
                businessId: businessId,
                message: message
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    getCacheData(startDate, endDate) {
        return new Promise<CacheData>(resolve => {
            this._getCacheData("Visit/GetDataForCache", {
                MemberId: this.workerData.MemberId,
                BusinessId: this.workerData.BusinessId,
                UserId: this.workerData.UserId,
                UserTypeId: this.workerData.UserTypeId,
                UserName: btoa(this.userData.Username),
                Password: btoa(this.userData.Password),
                startDate: startDate,
                endDate: endDate,
                language: Translate.currentLanguage,
                SupressAssignedPatient: true
            }).subscribe(data => {
                if (data == null) {
                    resolve(data);
                } else {
                    this.getServerTime().then(() => {
                        data.Visits = this.visitTimePromises(data.Visits);
                        data.AssignedPatients = this.assignedPatientTimePromises(data.AssignedPatients);
                        this.checkUnsyncedVisits(data.Visits, startDate, endDate).then(resultData => {
                            data.Visits = resultData;
                            resolve(data);
                        }).catch((e) => {
                            resolve(data);
                            console.log("error " + e);
                        });
                    }).catch((e) => {
                        resolve(data);
                        console.log("error " + e);
                    });
                }
            });
        });
    }

    getMemberInfo(startDate, endDate) {
        return new Promise<MemberInfo>(resolve => {
            this._getMemberInfo("Visit/GetMemberInfo", {
                memberId: this.workerData.MemberId,
                businessId: this.workerData.BusinessId,
                startDate: startDate,
                endDate: endDate
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    getMemberPhones() {
        return new Promise<CoPhone[]>(resolve => {
            this._getMemberPhones("Visit/GetMemberPhones", {
                memberId: this.workerData.MemberId,
                businessId: this.workerData.BusinessId
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    getCacheVisits(startDate, endDate, getTime = true): Promise<CacheVisit[]> {
        return new Promise<CacheVisit[]>(async resolve => {
            const interactionId = await this.newRelicService.startInteraction('getCacheVisits');
            this.newRelicService.recordBreadcrumb('getCacheVisits called', {
                startDate,
                endDate,
                getTime
            });

            try {
                if (!this.workerData) {
                    this.newRelicService.recordBreadcrumb('No worker data available');
                    return resolve([]);
                }

                const params = {
                    MemberId: this.workerData.MemberId,
                    BusinessId: this.workerData.BusinessId,
                    UserId: this.workerData.UserId,
                    UserTypeId: this.workerData.UserTypeId,
                    UserName: btoa(this.userData.Username),
                    Password: btoa(this.userData.Password),
                    startDate,
                    endDate,
                    language: Translate.currentLanguage,
                    SupressAssignedPatient: true
                };

                this._getCacheVisits("Visit/GetVisitsForCache", params).subscribe(
                    async data => {
                        if (!data) {
                            this.newRelicService.recordBreadcrumb('No visit data returned');
                            return resolve([]);
                        }

                        try {
                            await this.getServerTime();
                            data = this.visitTimePromises(data);
                            const resultData = await this.checkUnsyncedVisits(data, startDate, endDate);

                            this.newRelicService.recordBreadcrumb('Synced visit data processed', {
                                syncedCount: resultData.length,
                            });

                            if (getTime) {
                                const patientDate = moment().format(DateFormat);
                                const patientParams = {
                                    WorkerId: this.workerData.MemberId,
                                    BusinessId: this.workerData.BusinessId,
                                    Date: patientDate
                                };

                                this._getAssignedPatients("Patient/GetAssignedPatients", patientParams).subscribe(data2 => {
                                    this.assignedPatientTimePromises(data2);
                                    this.newRelicService.recordBreadcrumb('Assigned patients data processed');
                                });
                            }

                            resolve(resultData);
                        } catch (err) {
                            this.newRelicService.recordError('checkUnsyncedVisits error', err?.stack || err);
                            resolve(data);
                        }
                    },
                    error => {
                        this.newRelicService.recordError('API call to GetVisitsForCache failed', error?.stack || error);
                        resolve([]);
                    }
                );
            } catch (err) {
                this.newRelicService.recordError('Unhandled error in getCacheVisits', err?.stack || err);
                resolve([]);
            } finally {
                this.newRelicService.endInteraction(interactionId);
            }
        });
    }

    checkUnsyncedVisits(data: CacheVisit[], startDate, endDate) {
        return new Promise<CacheVisit[]>(resolve => {
            if (localStorage.getItem(this.visitSyncFailedKey) == "true" && data != null && this.workerData !== undefined && this.workerData != null) {
                var visitList: CacheVisit[] = [];
                visitList = data.map(x => new CacheVisit(x));
                this.storage.get(this.uptimeService.cacheVisitKey).then(visits => {
                    if (visits != null) {
                        visits = visits.filter(v => v.MemberId == this.workerData.MemberId && v.BusinessId == this.workerData.BusinessId);
                        var filteredVisits = this.filterVisitsByPickerDates(visits, startDate, endDate);
                        for (var filteredVisit of filteredVisits) {
                            var index = data.findIndex(v => (v.ServiceOrderId != 0 && v.ServiceOrderId == filteredVisit.ServiceOrderId));
                            if (index == -1 && filteredVisit.PatientServiceOrderId != 0 && filteredVisit.ServiceOrderId == 0) {
                                index = data.findIndex(v => v.MemberId == filteredVisit.MemberId && v.PatientId == filteredVisit.PatientId
                                    && moment(v.ArrivalTime, [DateTimeFormat, DateTimeWebFormat, MomentDefaultFormat]).isSame(moment(filteredVisit.ArrivalTime, [DateTimeFormat, DateTimeWebFormat, MomentDefaultFormat]), 'minute'));
                                if (index != -1) {
                                    if (data[index].ServiceOrderId == 0) {
                                        filteredVisit.SyncFailed = true;
                                    } else {
                                        filteredVisit.ServiceOrderId = data[index].ServiceOrderId;
                                        filteredVisit.SyncFailed = false;
                                        filteredVisit.PatientServiceOrderId = 0;
                                    }
                                }
                            }

                            if (index == -1) visitList.push(new CacheVisit(filteredVisit));
                            else if (filteredVisit.SyncFailed) {
                                visitList.splice(index, 1, filteredVisit);
                            }
                        }
                    }
                    resolve(visitList);
                }).catch((e) => {
                    resolve(data);
                    console.log("error " + e);
                });
            } else {
                resolve(data);
            }
        });
    }

    filterVisitsByPickerDates(visits: CacheVisit[], startDate, endDate) {
        let numberOfDays = parseInt(localStorage.getItem("numberOfDays"));
        let start = moment(startDate, [MomentDefaultFormat, DateTimeFormat, DateFormat]).subtract(numberOfDays, 'd').format(DateFormat);
        let end = moment(endDate, [MomentDefaultFormat, DateTimeFormat, DateFormat]).format(DateFormat);
        return visits.filter(v => {
            return moment(v.AppointmentDate, MomentFormats.momentFormats).isBetween(moment(start, DateFormat), moment(end, DateFormat).add(1, "day").add(-1, "seconds"), "second", "[]");
        });
    }

    visitIsSynced(visit: CacheVisit) {
        if (localStorage.getItem(this.visitSyncFailedKey) == "true" && visit.SyncFailed) {
            return false;
        }
        return true;
    }

    createVisit(serviceOrder: CacheVisit) {
        return new Promise<CacheVisit>(resolve => {
            this._createVisit("Visit/CreateVisit", {
                visit: serviceOrder,
                worker: this.workerData,
                arg:
                {
                    UserName: btoa(this.userData.Username),
                    Password: btoa(this.userData.Password)
                }
            }).subscribe(data => {
                if (data == null) {
                    localStorage.setItem(this.visitSyncFailedKey, "true");
                    serviceOrder.SyncFailed = true;
                    resolve(new CacheVisit(serviceOrder));
                } else {
                    if (data.ServiceOrderId != 0) {
                        this.storage.get(this.uptimeService.cacheAssignedPatientsKey).then(result => {
                            let index = result.findIndex(x => x.PatientId == serviceOrder.PatientId);
                            data.PatientTime = result[index].PatientTime;
                            data.PatientZone = result[index].PatientZone;
                            resolve(data);
                        }).catch((e) => {
                            resolve(data);
                            console.log("error " + e);
                        });
                    } else {
                        localStorage.setItem(this.visitSyncFailedKey, "true");
                        serviceOrder.SyncFailed = true;
                        resolve(new CacheVisit(serviceOrder));
                    }
                }
            });
        });
    }

    getAssignedPatientsDocuments(date: string) {
        return new Promise<CacheAssignedPatient[]>(resolve => {
            if (this.workerData !== undefined && this.workerData != null) {
                this._getAssignedPatientsDocuments("Patient/GetAssignedPatientsDocuments", {
                    WorkerId: this.workerData.MemberId,
                    BusinessId: this.workerData.BusinessId,
                    Date: date
                }).subscribe(data => {
                    this.getAllTimes();
                    this.getServerTime().then(() => {
                        data = this.assignedPatientTimePromises(data);
                        resolve(data);
                    }).catch((e) => {
                        resolve(data);
                    });
                });
            } else {
                resolve([]);
            }
        });
    }

    getAssignedPatients(date: string) {
        return new Promise<CacheAssignedPatient[]>(resolve => {
            if (this.workerData !== undefined && this.workerData != null) {
                this._getAssignedPatients("Patient/GetAssignedPatients", {
                    WorkerId: this.workerData.MemberId,
                    BusinessId: this.workerData.BusinessId,
                    Date: date
                }).subscribe(data => {
                    this.getAllTimes();
                    this.getServerTime().then(() => {
                        data = this.assignedPatientTimePromises(data);
                        resolve(data);
                    }).catch((e) => {
                        resolve(data);
                    });
                });
            } else {
                resolve([]);
            }
        });
    }

    sendCacheForSync(cacheData: CacheData) {
        return new Promise<any>(resolve => {
            this._sendCacheForSync("Visit/SynchronizeCacheToAnkota", {
                cache: cacheData
            }).subscribe(data => {
                if (data == 1) {
                    if (localStorage.getItem(this.visitSyncFailedKey) == "true") {
                        for (var i = 0; i < cacheData.Visits.length; i++) {
                            cacheData.Visits[i].SyncFailed = false;
                        }

                        var endDate = moment().toISOString();
                        var startDate = moment().toISOString();
                        var pastDays = parseInt(localStorage.getItem("numberOfDays"));
                        startDate = pastDays > 0 ? moment(startDate).add(-pastDays, 'd').toISOString() : startDate;
                        this.getCacheVisits(moment(startDate).format(DateTimeFormat), moment(endDate).format(DateTimeFormat)).then(visits => {
                            this.storage.set(this.uptimeService.cacheVisitKey, visits);
                            localStorage.setItem(this.visitSyncFailedKey, "false");
                        });
                    }
                } else {
                    for (var i = 0; i < cacheData.Visits.length; i++) {
                        cacheData.Visits[i].SyncFailed = true;
                    }
                    this.storage.set(this.uptimeService.cacheVisitKey, cacheData.Visits);
                    localStorage.setItem(this.visitSyncFailedKey, "true");
                }
                resolve(data);
            });
        });
    }

    getVisitUpdatesForCache(serviceOrderId: number, startDate, endDate) {
        return new Promise<CacheVisit>(resolve => {
            this._getVisitUpdatesForCache("Visit/GetVisitUpdatesForCache", {
                serviceOrderId: serviceOrderId,
                MemberId: this.workerData.MemberId,
                BusinessId: this.workerData.BusinessId,
                UserId: this.workerData.UserId,
                UserTypeId: this.workerData.UserTypeId,
                UserName: btoa(this.userData.Username),
                Password: btoa(this.userData.Password),
                startDate: startDate,
                endDate: endDate
            }).subscribe(data => {
                if (data == null) {
                    resolve(data);
                } else {
                    this.storage.get(this.uptimeService.cacheVisitKey).then(results => {
                        let index = results.findIndex(x => x.ServiceOrderId == serviceOrderId);
                        if (index != -1) {
                            data.PatientTime = results[index].PatientTime;
                            data.PatientZone = results[index].PatientZone;
                        }
                        resolve(data);
                    }).catch((e) => {
                        resolve(data);
                        console.log("error " + e);
                    });
                }
            });
        })
    }

    saveProvidedCoordinates(serviceOrderId: number, latitude: number, longitude: number, isArrival: boolean) {
        return new Promise<CacheVisit>(resolve => {
            if (serviceOrderId != null && serviceOrderId !== undefined) {
                this._saveProvidedCoordinates("Visit/SaveProvidedCoordinates", {
                    serviceOrderId: serviceOrderId,
                    providedLatitude: latitude,
                    providedLongitude: longitude,
                    isArrival: isArrival
                }).subscribe(data => {
                    resolve(data);
                });
            } else {
                resolve(null);
            }
        });
    }

    getDataForMapDirections(visit: CacheVisit, startDate: string, endDate: string, currentClientDateTime: string) {
        return new Promise<VisitDirectionsEntity>(resolve => {
            this._getDataForMapDirections("Visit/GetDataForMapDirections", {
                visit: visit,
                startDate: startDate,
                endDate: endDate,
                currentClientDateTime: currentClientDateTime
            }).subscribe(data => {
                resolve(data);
            });
        })
    }


    savePatientConcerns(serviceOrderId, patientConcerns) {
        return new Promise<any>(resolve => {
            this._savePatientConcernsForVisit("Visit/SavePatientConcerns",
                {
                    ServiceOrderId: serviceOrderId,
                    PatientConcerns: patientConcerns,
                    UserId: this.workerData.UserId
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    saveUserPassword(password) {
        return new Promise<any>(resolve => {
            this._savePatientConcernsForVisit("Business/ContactChangePassword",
                {
                    userId: this.workerData.UserId,
                    newPassword: password
                }).subscribe(data => {
                    resolve(data);
                });
        });
    }

    uploadMemberFile(file, workerDocument: CacheConfigurableListItem) {
        return new Promise<any>(resolve => {
            var formData: FormData = new FormData();
            formData.append(file.name, file, file.name);
            formData.append("orgId", this.workerData.BusinessId.toString());
            formData.append("memberId", this.workerData.MemberId.toString());
            formData.append("documentType", workerDocument.Description.toString());
            formData.append("folderId", workerDocument.FolderID.toString());
            this.http.post(this.baseUrl + "Member/UploadWorkerDocuments", formData).subscribe((data) => {
                resolve(data);
            });
        })
    }


    getWorkerCalendar() {
        return new Promise<Slot[]>(resolve => {
            this._getCalendarSlot("Member/GetWorkerCalendar", {
                memberId: this.workerData.MemberId,
                businessId: this.workerData.BusinessId,
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    getWorkerAvailableShifts() {
        return new Promise<AvailableShift[]>(resolve => {
            if (this.workerData) {
                this._getWorkerAvailableShifts("Member/GetWorkerAvailableShifts", {
                    memberId: this.workerData.MemberId,
                    businessId: this.workerData.BusinessId,
                }).subscribe(data => {
                    resolve(data);
                });
            } else {
                resolve([]);
            }
        });
    }

    getShiftUpdate(serviceOrderId: number) {
        return new Promise<AvailableShift>(resolve => {
            this._getShiftUpdate("Member/GetShiftUpdate", {
                ServiceOrderId: serviceOrderId
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    getShiftUpdateForContiguousVisits(shift: AvailableShift) {
        return new Promise<AvailableShift>(resolve => {
            this._getShiftUpdateForContiguousVisits("Member/GetShiftUpdateForContiguousVisits", {
                shift: shift
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    getWorkerRequestedShifts() {
        return new Promise<AvailableShift[]>(resolve => {
            if (this.workerData) {
                this._getWorkerAvailableShifts("Member/GetWorkerRequestedShifts", {
                    memberId: this.workerData.MemberId,
                    businessId: this.workerData.BusinessId,
                }).subscribe(data => {
                    resolve(data);
                });
            } else {
                resolve([]);
            }
        });
    }

    getWorkerDeclinedShifts() {
        return new Promise<AvailableShift[]>(resolve => {
            if (this.workerData) {
                this._getWorkerAvailableShifts("Member/GetWorkerDeclinedShifts", {
                    memberId: this.workerData.MemberId,
                    businessId: this.workerData.BusinessId,
                }).subscribe(data => {
                    resolve(data);
                });
            } else {
                resolve([]);
            }
        });
    }

    AcceptShift(shift: AvailableShift) {
        return new Promise<any>(resolve => {
            this._acceptShift("Member/AcceptShift", {
                businessId: this.workerData.BusinessId,
                memberId: this.workerData.MemberId,
                userId: this.workerData.UserId,
                shift: shift
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    RequestShift(shift: AvailableShift) {
        return new Promise<any>(resolve => {
            this._requestShift("Member/RequestShift", {
                businessId: this.workerData.BusinessId,
                memberId: this.workerData.MemberId,
                userId: this.workerData.UserId,
                shift: shift
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    DeclineShift(shift: AvailableShift) {
        return new Promise<any>(resolve => {
            this._declineShift("Member/DeclineShift", {
                businessId: this.workerData.BusinessId,
                memberId: this.workerData.MemberId,
                userId: this.workerData.UserId,
                shift: shift
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    UpdatePhonesDetails(phones: CoPhone[]) {
        return new Promise<any>(resolve => {
            this._updatePhonesDetails("Member/UpdatePhonesDetails", {
                phones: phones
            }).subscribe(data => {
                resolve(data);
            });
        });
    }


    getWorkerAdjustments(startDate: Date, endDate: Date) {
        return new Promise<AdjustmentSlot[]>(resolve => {
            if (this.workerData) {
                this._getAdjustmentSlot("Member/GetCalendarWorkTimeAdjustments", {
                    StartDate: startDate,
                    EndDate: endDate,
                    MemberId: this.workerData.MemberId,
                    BusinessId: this.workerData.BusinessId,
                }).subscribe(data => {
                    resolve(data);
                });
            } else {
                resolve([]);
            }
        });
    }


    getWorkerCalendarTemplateID() {
        return new Promise<number>(resolve => {
            this._getWorkerCalendarTemplateID("Member/GetWorkerCalendarID", {
                memberId: this.workerData.MemberId,
            }).subscribe(data => {
                resolve(data);
            });
        });
    }
    getMemberVisitsPerWeek() {
        return new Promise<number>(resolve => {
            if (this.workerData) {
                this._getMemberVisitsPerWeek("Member/GetMemberVisitsPerWeek", {
                    memberId: this.workerData.MemberId,
                }).subscribe(data => {
                    resolve(data);
                });
            } else {
                resolve(0);
            }
        });
    }

    saveMemberVisitsPerWeek(visitsPerWeek: number) {
        return new Promise<any>(resolve => {
            if (this.workerData) {
                this._saveMemberVisitsPerWeek("Member/SaveMemberVisitsPerWeek",
                    {
                        memberId: this.workerData.MemberId,
                        visitsPerWeek: visitsPerWeek,
                    }).subscribe(data => {
                        resolve(data);
                    });
            } else {
                resolve([]);
            }
        })
    }

    _saveMemberVisitsPerWeek(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _savePatientConcernsForVisit(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _getDataForMapDirections(url: string, paramData: any): Observable<VisitDirectionsEntity> {
        return this.postData(url, paramData);
    }

    _saveProvidedCoordinates(url: string, paramData: any): Observable<CacheVisit> {
        return this.postData(url, paramData);
    }

    _getVisitUpdatesForCache(url: string, paramData: any): Observable<CacheVisit> {
        return this.postData(url, paramData);
    }

    _sendCacheForSync(url: string, paramData: any): Observable<number> { //CacheVisit[]
        return this.postData(url, paramData);
    }

    _getCacheVisits(url: string, paramData: any): Observable<CacheVisit[]> {
        return this.postData(url, paramData);
    }

    _createVisit(url: string, paramData: any): Observable<CacheVisit> {
        return this.postData(url, paramData);
    }

    _getAssignedPatients(url: string, paramData: any): Observable<CacheAssignedPatient[]> {
        return this.postData(url, paramData);
    }

    _getAssignedPatientsDocuments(url: string, paramData: any): Observable<CacheAssignedPatient[]> {
        return this.postData(url, paramData);
    }

    _getCacheData(url: string, paramData: any): Observable<CacheData> {
        return this.postData(url, paramData);
    }

    _getMemberInfo(url: string, paramData: any): Observable<MemberInfo> {
        return this.postData(url, paramData);
    }
    _getMemberPhones(url: string, paramData: any): Observable<CoPhone[]> {
        return this.postData(url, paramData);
    }

    _getCalendarSlot(url: string, paramData: any): Observable<Slot[]> {
        return this.postData(url, paramData);
    }

    _getWorkerAvailableShifts(url: string, paramData: any): Observable<AvailableShift[]> {
        return this.postData(url, paramData);
    }

    _getShiftUpdate(url: string, paramData: any): Observable<AvailableShift> {
        return this.postData(url, paramData);
    }

    _getShiftUpdateForContiguousVisits(url: string, paramData: any): Observable<AvailableShift> {
        return this.postData(url, paramData);
    }

    _acceptShift(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _requestShift(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _declineShift(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _updatePhonesDetails(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _saveErrandMiles(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _getAdjustmentSlot(url: string, paramData: any): Observable<AdjustmentSlot[]> {
        return this.postData(url, paramData);
    }

    _getMemberVisitsPerWeek(url: string, paramData: any): Observable<number> {
        return this.postData(url, paramData);
    }

    _getWorkerCalendarTemplateID(url: string, paramData: any): Observable<number> {
        return this.postData(url, paramData);
    }

    _getConfigurationValueByMessage(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _getContiguousVisitList(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _getPatientTime(url: string, paramData: any): Observable<string> {
        return this.postData(url, paramData);
    }

    _getTimePing(url: string, paramData: any): Observable<Object> {
        return this.postDataPing(url, paramData);
    }

    _getUTCTime(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _checkIfShouldDepart(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _updateVisitBreakDuration(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _checkIfAnotherWorkerIsClockedIn(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _checkGpsCoordinates(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _sendForLogging(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _saveCarePlanItemValues(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _saveVitalSignCarePlan(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _getCarePlanItems(url: string, paramData: any): Observable<CacheCarePlanItem[]> {
        return this.postData(url, paramData);
    }

    _markMessagesAsRead(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _getExpiringHrRequirementsForNotificationCenter(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _getUserMessagesForNotificationCenter(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _sendMessageForUser(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _logAuthCode(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _getVisitTypeDetails(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getErrandMilesForVisits(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }
    
    saveNotesForVisits(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getTimesheetUrls(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    declineVisitAndMarkAsSearched(url: string, paramData: any): Observable<CacheVisit> {
        return this.postData(url, paramData);
    }

    _deviceWasAlreadyLogged(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getVisitsForNotification(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getUpcomingVisitsForWorker(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getPayrollSummaryForWorker(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getPayrollHistoryForWorker(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getVisitHistoryForWorker(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getWorkerVisitsForCalendar(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getWeeklyHoursSummaryWorker(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }
    getWeeklyHoursForTotalWorker(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    savePatientConfirmationUrl(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    updateVisitStatusAndTechnician(url: string, paramData: any): Observable<CacheVisit> {
        return this.postData(url, paramData);
    }

    getVisitsWithMatchingSkills(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    uploadSignatureToServer(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    checkAllowed(url: string, paramData: any): Observable<TimeConstraint> {
        return this.postData(url, paramData);
    }

    getAssignedClients(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    acceptArrivalTime(url: string, paramData: any): Observable<CacheVisit> {

        return this.postData(url, paramData);
    }

    acceptDepartureTime(url: string, paramData: any): Observable<CacheVisit> {

        return this.postData(url, paramData);
    }

    getMainMenuPagesConfiguration(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getConfigurationsForBusiness(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getConfigurationByUsernameAndPassword(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getUpcomingVisitDetails(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _sendAuthCodeToWorker(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getPasswordAndLoginSettings(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getBlockedWords(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    changePassword(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    postData(url: string, paramData: any): Observable<any> {
        const fullUrl = this.baseUrl + url;
        const startTime = Date.now();

        const headers = new HttpHeaders({
            'Authorization': 'bearer ' + this.access_token
        });

        return this.http.post(fullUrl, paramData, { headers }).pipe(
            tap(response => {
                const endTime = Date.now();

                this.newRelicService.trackHttpTransaction(
                    fullUrl,
                    'POST',
                    200,
                    startTime,
                    endTime,
                    paramData,
                    response
                );
            }),
            catchError(error => {
                const endTime = Date.now();

                this.newRelicService.trackHttpFailure(
                    fullUrl,
                    'POST',
                    startTime,
                    endTime,
                    error
                );

                return throwError(error);
            })
        );
    }


    addBiometric(url: string, paramData: any): Observable<any> {
        return this.postData(url, paramData);
    }

    getChallenge(url: string, paramData: any): Observable<any> {
        return this.postData(url, paramData);
    }

    verifySignature(url: string, paramData: any): Observable<any> {
        return this.postData(url, paramData);
    }

    registerFace(url: string, paramData: any): Observable<any> {
        return this.postData(url, paramData);
    }

    deleteCalendarWorkTime(id: number, dayNo: number, templateID: number): Observable<any> {
        return this.postData("Member/DeleteCalendarWorkTime", { calendarID: id, day: dayNo, calendarTemplateID: templateID });
    }

    deleteCalendarWorkTimeAdjustment(id: number): Observable<any> {
        return this.postData("Member/DeleteCalendarWorkTimeAdjustment", { id: id });
    }

    saveWorkerCalendar(slot2: Slot, shouldUpdate: boolean): Observable<any> {
        return this.postData("Member/SaveWorkerCalendar",
            {
                cal: slot2,
                calendarTemplateNeedsUpdate: shouldUpdate
            });
    }

    saveWorkerCalendarList(slots: Slot[], shouldUpdate: boolean): Promise<any> {
        return new Promise<any>(resolve => {
            this.postData("Member/SaveWorkerCalendarBulk",
                {
                    calendars: slots,
                    calendarTemplateNeedsUpdate: shouldUpdate
                }).subscribe(data => {
                    resolve(data);
                })
        });
    }

    saveCalendarWorkTimeAdjustmen(slot: AdjustmentSlot): Observable<any> {
        slot.MemberId = this.workerData.MemberId;
        slot.BusinessID = this.workerData.BusinessId
        return this.postData("Member/SaveCalendarWorkTimeAdjustment", slot);
    }


    getDocumentsByVisit(serviceOrderID) {
        return this.postData("Visit/GetVisitDocuments", { serviceOrderID: serviceOrderID });
    }

    processVisitDocuments(serviceOrderID, data) {
        return this.postData("Visit/ProcessVisitDocuments", { "serviceOrderID": serviceOrderID, "data": data });
    }

    _getCarePlanItemHistory(url: string, paramData: any): Observable<any> {
        return this.postData(url, paramData);
    }

    _getVisitHistoryForPatient(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    _getMemberById(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    saveCalendaTemplate(dayNo: number, date: string) {
        return this.postData("Member/SaveCalendarTemplate",
            {
                workerId: this.workerData.MemberId,
                templateName: this.workerData.LastName + ", " + this.workerData.FirstName + " " + date,
                dayNo: dayNo
            });
    }

    getPatientDocuments(patientId: number, businessId: number) {
        return new Promise<any>(resolve => {
            if (patientId !== undefined && patientId != null && patientId != 0) {
                this.getAllPatientDocuments("Support/GetDocumentsById",
                    {
                        patientID: patientId,
                        businessID: businessId
                    }).subscribe(data => {
                        resolve(data);
                    });
            } else {
                resolve([]);
            }
        })
    }

    getAllPatientDocuments(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }

    getVisitProcessedDocuments(serviceOrderID): Promise<any> {
        return new Promise<any>(resolve => {
            this.getVisitHistoryForWorker("Visit/GetVisitProcessedDocuments",
                {
                    serviceOrderID: serviceOrderID
                }).subscribe(data => {
                    resolve(data);
                })
        })
    }

    getMissedVisitReasons(): Promise<any> {
        return new Promise<any>(resolve => {
            this.getConfigurationsForBusiness("Business/GetMisssedVisitReasonsList",
                {
                    businessId: this.workerData.BusinessId
                }).subscribe(data => {
                    this.businessConfigurations = data;
                    resolve(data);
                });
        });
    }

    getWorkerRequiredDocumentsList(): Promise<any> {
        return new Promise<any>(resolve => {
            this.getConfigurationsForBusiness("Business/GetWorkerRequiredDocumentsList",
                {
                    businessId: this.workerData.BusinessId
                }).subscribe(data => {
                    this.businessConfigurations = data;
                    resolve(data);
                });
        });
    }

    getVisitHistoryForPatient(patientId: number, startDate, endDate) {
        return new Promise<any>(resolve => {
            this._getVisitHistoryForPatient("Visit/GetVisitHistoryForPatient", {
                businessId: this.workerData.BusinessId,
                patientId: patientId,
                startDate: startDate,
                endDate: endDate
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    getMemberById(memberId: number) {
        return new Promise<any>(resolve => {
            this._getMemberById("Member/GetMemberById", {
                memberId: memberId
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    postDataPing(url: string, paramData: any): Observable<Object> {

        var headers = new HttpHeaders();
        headers.append('Authorization', 'bearer ' + this.access_token);
        var params = new HttpParams();
        if (paramData) {
            for (var p in paramData) {
                params = params.set(p, paramData[p]);
            }
        }

        return this.http.post(this.baseUrl + url, paramData, { headers: headers })
            .pipe(
                timeout(5000),
                catchError((error) => {
                    if (error instanceof TimeoutError) {
                        console.log(error);
                    }

                    return throwError(error);
                }),
                finalize(() => {
                    //console.log('Request it is over');
                })
            );
    }

    getTimePing() {
        var timePromise = () => new Promise<any>((resolve, reject) => {
            this._getUTCTime("Visit/GetUTCTime", {
                timezone: 0
            }).subscribe(data => {
                if (this.pingIndex < this.maxPingTimes) {
                    this.pingIndex++;
                    this.timeArray.push(moment(data, DateTimeWebFormat).format(DateTimeFormat));

                    resolve(timePromise());
                } else {
                    resolve(data);
                }
            }, error => {
                reject(error);
            });
        });

        return timePromise();
    }

    pingServer() {
        var pingDiff = 0;
        this.pingIndex = 0;
        this.timeArray = [];
        return this.getTimePing().then(data => {
            var sortedArray = this.timeArray.sort((a, b) => a.valueOf() - b.valueOf())
            for (var i = 1; i < sortedArray.length; i++) {
                var diff = Math.abs(moment(sortedArray[i], DateTimeFormat).diff(moment(sortedArray[i - 1], DateTimeFormat)));
                pingDiff += diff;
            }
            if (pingDiff / (this.maxPingTimes - 1) > this.pingAllowedDelay) {
                this.offlineMode = true;
            } else {
                this.offlineMode = false;
            }
            this.emitOfflineMode(this.offlineMode);

            this.delayStr = "Offline Mode: " + this.offlineMode + " " + pingDiff / (this.maxPingTimes - 1) + " > " + this.pingAllowedDelay;
        }).catch((error) => {
            this.pingTimes = this.maxPingTimes;
            this.offlineMode = true;

            this.delayStr = "Time error: " + error;
        });
    }

    emitOfflineMode(val) {
        this.offlineModeObservable.next(val);
    }

    sendWorkerCoordinates(cacheWorkerCoordinates: CacheWorkerCoordinates) {
        return new Promise<any>(resolve => {
            this._sendWorkerCoordinates("Member/SendWorkerCoordinates", {
                workerCoordinates: cacheWorkerCoordinates
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    _sendWorkerCoordinates(url: string, paramData: any): Observable<CacheWorkerCoordinates> {
        return this.postData(url, paramData);
    }

    getPatientAuthorization(sistemPatientId2: number, date: string) {
        return new Promise<any>(resolve => {
            this.getAuthorizations("CareTrack/GetAllAuthorizations", {
                workerId: 0,
                patientId: sistemPatientId2 ? sistemPatientId2 : 13236,
                date: date,
                businessId: this.workerData.BusinessId
            }).subscribe(data => {
                resolve(data);
            });
        });
    }

    getAuthorizations(url: string, paramData: any): Observable<Object> {
        return this.postData(url, paramData);
    }
}